import React, { useState, useEffect } from 'react';
import { Menu, X, ShoppingBag } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Inicio', href: '#hero' },
    { name: 'Marcas', href: '#brands' },
    { name: 'Productos', href: '#products' },
    { name: 'Looks', href: '#looks' }
  ];

  return (
    <nav 
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'nav-scrolled py-4' 
          : 'bg-transparent py-6'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="https://styleoutlet.es" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="navbar-logo"
            className="font-serif text-2xl md:text-3xl font-bold text-[#111111] hover:text-[#C8A96A] transition-colors cursor-pointer"
          >
            Style<span className="text-[#C8A96A]">Outlet</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="font-sans text-sm font-bold tracking-wider uppercase text-[#111111] hover:text-[#C8A96A] transition-colors underline-animation cursor-pointer"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a 
              href="https://styleoutlet.es" 
              target="_blank" 
              rel="noopener noreferrer"
              data-testid="navbar-cta"
              className="inline-flex items-center gap-2 bg-[#111111] hover:bg-[#C8A96A] text-white px-6 py-3 font-bold text-sm tracking-wider uppercase transition-all duration-300 cursor-pointer"
            >
              <ShoppingBag className="w-4 h-4" />
              Comprar
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#111111] cursor-pointer"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div 
            data-testid="mobile-menu"
            className="md:hidden absolute top-full left-0 right-0 bg-[#EDE7E1] border-t border-[#111111]/10 py-6 px-6 animate-fade-in"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="font-sans text-lg font-bold text-[#111111] hover:text-[#C8A96A] transition-colors py-2 cursor-pointer"
                >
                  {link.name}
                </a>
              ))}
              <a 
                href="https://styleoutlet.es" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center justify-center gap-2 bg-[#C8A96A] text-white px-6 py-4 font-bold text-sm tracking-wider uppercase cursor-pointer"
              >
                <ShoppingBag className="w-4 h-4" />
                Comprar ahora
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
